<template>
    <div class="plans"> 
        <PageTitle main="Meu Plano" sub="" />
       
        <div id="pageGrid" >
            <div id="barraBotoes">
                <b-row>
                    <b-col cols="10" class="text-left">
                        <b-button variant="secondary" 
                            @click="openTermoUso()" size="lgx" class="mb-2 mr-2">  
                            <i class="fa fa-print"></i> Termo de Uso
                        </b-button>
                        <b-button variant="secondary" 
                            @click="openPolitica()" size="lgx" class="mb-2 mr-2">  
                            <i class="fa fa-print"></i> Política de Privacidade
                        </b-button>
                    </b-col>
                </b-row>
            </div>   
            
            <b-table :items="plans" :fields="fields"
                responsive 
                striped
                borderless>               
                <template slot="situacoes" slot-scope="data">
                    <b-badge style="padding:6px 0px 6px 0px; width: 100px;" 
                            :variant="getStatusItem(data.item.fl_situacao)">
                            {{data.item.status}}
                    </b-badge>
                </template>
                <template slot="actions" slot-scope="data">
                    <b-button variant="success" title="Pagar" v-show="(data.item.fl_situacao == 'A')" 
                        style="padding:2px 0px 2px 0px; width: 80px;"
                        @click="loadPagar(data.item)" size="sm mr-2">  
                        Pagar
                    </b-button>
                    <div v-show="(data.item.fl_situacao == 'Q')">
                        <img src="@/assets/check-pay.png" width="24" alt="Pago" />
                    </div>                        
                </template>
            </b-table>             
            <b-pagination class="customPagination mt-4" size="md" v-model.trim="page" :total-rows="count" :per-page="limit" />
        </div>

    </div>  
</template>

<script>
import { baseApiUrl } from '@/global'
import { mapState } from 'vuex'
import axios from 'axios'
import PageTitle from '../template/PageTitle'
import Modal  from '../template/Modal'

export default {
    name: 'Planos',

    computed: mapState(['user']),
    
    components: { PageTitle, Modal },

    data: function () {
        return {
            mode: 'save',
            plans: [],          
            fields: [
                { key: 'contaspagrec_id', label: 'ID', sortable: true },
                { key: 'nm_plano', label: 'Plano', sortable: true },
                { key: 'dt_emissao', label: 'Emissão', sortable: true },
                { key: 'dt_vencimento', label: 'Vencimento', sortable: true },
                { key: 'dt_pagamento', label: 'Pagamento', sortable: true },
                { key: 'vlr_total', label: 'Valor', sortable: true },
                { key: 'situacoes', label: 'Status da Fatura' },  
                { key: 'actions', label: '', class: 'text-center' }
            ],
            page: 1,
            count: 0,
            limit: 0,

            getStatusItem: (situacao) => {
                let classeSituacao;
                switch (situacao) {
                    case 'A':
                        classeSituacao = "primary";
                        break;
                    case 'Q':
                        classeSituacao = "success";
                        break;
                    default:
                        classeSituacao = "primary";
                }
                return classeSituacao;
            }            
        }
    },

    methods: {
        loadPlans() {
            axios.get(`${baseApiUrl}/plano/registro/${this.$store.state.user.regid}/pagina/${this.page}`)
                 .then(resp => {
                     this.plans = resp.data.data
                     this.count = parseInt(resp.data.count)
                     this.limit = parseInt(resp.data.limit)
            })
        },

        loadPagar() {
            this.$toasted.global.defaultWarning({ msg: 'Em breve integração com Greenn Pagamentos!'})
		},
        
        openTermoUso() {
            window.open("https://sigame.digital/termos-de-uso", "_blank");
		},

        openPolitica() {
            window.open("https://sigame.digital/politica-de-privacidade", "_blank");
		}
    },

    watch: {
        page() {
            this.loadPlans()
        }
    },

    mounted() {
        this.loadPlans() 
    }        

}

</script>

<style scoped>
    
</style>